const actions = {
  FETCH_PRODUCTS: 'FETCH_PRODUCTS',
  FETCH_PRODUCTS_SUCCESS: 'FETCH_PRODUCTS_SUCCESS',
  FETCH_PRODUCTS_ERROR: 'FETCH_PRODUCTS_ERROR',
  PRODUCT_SET: 'product/SET_VALUE',
  PRODUCT_ADD: 'product/ADD_VALUE',
  PRODUCT_DEL: 'product/DEL_VALUE',
  PRODUCT_SUCCESS: 'product/SUCCESS',
  PRODUCT_ERROR: 'product/ERROR',
}

export default actions
